export const UserRoles = Object.freeze({
  INACTIVE_USER: 1,
  SUPER_ADMIN: 2,
  ADMIN: 3,
  USER: 4,
  GUEST_USER: 5
});

export const ecclesiaOptions = [
  { value: 1, label: 'Book Road' },
  { value: 2, label: 'Another Ecclesia' },
  { value: 3, label: 'Other' }
];


export const roles = {
  1: "Inactive User",
  2: "Super Admin",
  3: "Administrator",
  4: "Junior CYC Admin",
  5: "Senior CYC Admin",
  6: "Recording Secretary Admin",
  7: "Audio Visual",
  8: "Registered User",
  9: "Sunday School",
  10: "Affiliate Ecclesia Member",
  11: "Interested Visitor"
};